import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-fund',
  standalone: false,
  templateUrl: './fund.component.html',
  styleUrl: './fund.component.scss'
})
export class FundComponent implements OnInit, OnDestroy {
  title = 'Fund Table';

  fundData: any[] = [];
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  cols: any[] = [
    { field: 'name', header: 'Fund Name', filterType: 'text', width: '300px' },
    // { field: 'code', header: 'Fund Code', filterType: 'text', width: '300px' },
    { field: 'minor_head', header: 'Minor Head', filterType: 'text', width: '300px' },
    // { field: 'minor_head_code', header: 'Minor Head Code', filterType: 'text', width: '300px' },
    { field: 'major_head', header: 'Major Head', filterType: 'text', width: '200px' },
    // { field: 'major_head_code', header: 'Major Head Code', filterType: 'text', width: '200px' },
    // { field: 'status', header: 'Status', filterType: 'text', width: '150px' },
  ];
  unitsystem: any;
  showDeleteDialog: boolean = false;
  selectedFundData: any = {};
  viewMode: boolean = false;
  
  // Dialog configurations
  addDialogConfig: DialogConfig;
  updateDialogConfig: DialogConfig;
  
  private subscriptions = new Subscription();
  constructor(private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.initializeDialogConfigs();
  }

  private initializeDialogConfigs(): void {
    const fundFields: FormField[] = [
      {
        key: 'fund_code',
        label: 'Fund Code',
        type: 'text',
        placeholder: 'Enter Fund Code',
        maxLength: 50,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Fund Code must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'fund_name',
        label: 'Fund Name',
        type: 'text',
        placeholder: 'Enter Fund Name',
        maxLength: 100,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Fund Name must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'major_head_code',
        label: 'Major Head Code',
        type: 'text',
        placeholder: 'Enter Major Head Code',
        maxLength: 50,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Major Head Code must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'major_head',
        label: 'Major Head Name',
        type: 'text',
        placeholder: 'Enter Major Head Name',
        maxLength: 100,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Major Head Name must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'minor_head_code',
        label: 'Minor Head Code',
        type: 'text',
        placeholder: 'Enter Minor Head Code',
        maxLength: 50,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Minor Head Code must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'minor_head',
        label: 'Minor Head Name',
        type: 'text',
        placeholder: 'Enter Minor Head Name',
        maxLength: 100,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Minor Head Name must be alphanumeric and can include spaces and \'&\' only.'
      }
    ];

    this.addDialogConfig = {
      title: 'Create Fund',
      width: '80vw',
      fields: fundFields,
      formLayout: 'two-column',
      submitButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-fund-dialog'
    };

    this.updateDialogConfig = {
      title: 'Update Fund',
      width: '80vw',
      fields: fundFields,
      formLayout: 'two-column',
      submitButtonText: 'Update',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      maximizable: true,
      closable: true,
      dismissableMask: true,
      styleClass: 'custom-fund-dialog'
    };
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/fund/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
      let resp = res.data || res.results
      this.totalRecords = res.count || 0
      this.fundData = resp?.map((item: any) => ({
        ...item,
        minor_head: item?.minor_head || '',
        minor_head_code: item?.minor_head_code || '',
        major_head: item?.major_head || '',
        major_head_code: item?.major_head_code || '',
        fund_name: item?.name || '',
        fund_code: item?.code,
        status: item.status === 1 ? 'Active' : 'Inactive' // readable status
      }));
    });
    this.subscriptions.add(sub);
  }


  addEquipment() {
    this.selectedFundData = {};
    this.showDialog = true;
  }

  onSubmitAdd(formData: any) {
    let payload = {
      minor_head: formData.minor_head,
      minor_head_code: formData.minor_head_code,
      major_head: formData.major_head,
      major_head_code: formData.major_head_code,
      name: formData.fund_name,
      code: formData.fund_code,
      status: 1,
    };

    const sub = this.api.postAPI('/master/fund/', payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Fund submitted successfully',
        });
        this.showDialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: res.name || 'Failed to create fund',
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelAdd() {
    this.showDialog = false;
  }

  onCloseAdd() {
    this.showDialog = false;
  }
  viewSystem(rowData: any) {
    this.viewMode = true;
    this.updateDialogConfig.title = 'View Fund';
    if (rowData && rowData.id) {
      this.isUpdatedialog = true;
      this.unitsystem = rowData;
      
      // Map data for the reusable dialog
      this.selectedFundData = {
        fund_code: rowData.code || '',
        fund_name: rowData.name || '',
        major_head_code: rowData.major_head_code || '',
        major_head: rowData.major_head || '',
        minor_head_code: rowData.minor_head_code || '',
        minor_head: rowData.minor_head || ''
      };
    }
  }

  updateFund(unit: any): void {
    this.viewMode = false;
    this.updateDialogConfig.title = 'Update Fund';
    if (unit) {
      this.isUpdatedialog = true;
      this.unitsystem = unit;
      
      // Map data for the reusable dialog
      this.selectedFundData = {
        fund_code: unit.code || '',
        fund_name: unit.name || '',
        major_head_code: unit.major_head_code || '',
        major_head: unit.major_head || '',
        minor_head_code: unit.minor_head_code || '',
        minor_head: unit.minor_head || ''
      };
    } else {
      console.error('No fund data provided for editing');
    }
  }

  onSubmitUpdate(formData: any) {
    let sectionId = this.unitsystem.id;
    let payload = {
      minor_head: formData.minor_head,
      minor_head_code: formData.minor_head_code,
      major_head: formData.major_head,
      major_head_code: formData.major_head_code,
      name: formData.fund_name,
      code: formData.fund_code,
      status: 1
    };
    
    const sub = this.api.putAPI(`/master/fund/${sectionId}/`, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Fund updated successfully'
        });
        this.isUpdatedialog = false;
        this.getSystem();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: res.detail || 'Failed to update fund'
        });
      }
    });
    this.subscriptions.add(sub);
  }

  onCancelUpdate() {
    this.isUpdatedialog = false;
  }

  onCloseUpdate() {
    this.isUpdatedialog = false;
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.unitsystem = equipment
  }

  deleteequipment() {
    let sectionId = this.unitsystem.id
    const sub = this.api.deleteAPI(`/master/fund/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: ' Deleted Successfully',
        });
        // window.location.reload();
        this.showDeleteDialog = false
        this.getSystem()

      },

      error: (err) => {
        console.error('API Error:', err);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Error',
        //   detail: 'Failed to delete . Please try again.',
        // });
      },
    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/fund', 'Edit') ||
      this.permissionService.hasPrivilege('/master/fund', 'Delete') ||
      this.permissionService.hasPrivilege('/master/fund', 'View');
  }
}
